import { useEffect, useState } from "react";
import http from "@/api";
import { RECOGNITION_META, toBase10 } from "@/constants";
import { CalendarClock } from "lucide-react";

export default function WeeklyDigest() {
  const [data, setData] = useState(null);

  useEffect(() => {
    http.get("/admin/weekly-digest").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const lbl = (k) => (k ? (data.labels?.[k] || RECOGNITION_META[k]?.label || k) : "Sin datos");

  return (
    <section className="sketch-border bg-[var(--cream-soft)] p-6 mt-8" data-testid="weekly-digest">
      <div className="font-hand text-xl text-[var(--lala-blue)] flex items-center gap-1.5">
        <CalendarClock size={16} /> resumen de los últimos 7 días
      </div>
      <h3 className="font-display text-2xl mb-4">Actividad de la semana</h3>
      <div className="grid sm:grid-cols-4 gap-4">
        <div className="p-4 rounded-xl bg-[var(--cream)] border border-[var(--line)]">
          <div className="font-display text-4xl text-[var(--lala-blue)]" data-testid="digest-captures">{data.captures_last_7d}</div>
          <div className="text-xs text-[var(--ink-soft)] mt-1">capturas de KPI registradas</div>
        </div>
        <div className="p-4 rounded-xl bg-[var(--cream)] border border-[var(--line)]">
          <div className="font-display text-4xl text-[var(--lala-blue)]" data-testid="digest-proposals-pending">{data.kpi_proposals_pending ?? 0}</div>
          <div className="text-xs text-[var(--ink-soft)] mt-1">propuestas de KPI por aprobar</div>
        </div>
        <div className="p-4 rounded-xl bg-[var(--cream)] border border-[var(--line)]">
          <div className="font-display text-4xl text-[var(--lala-blue)]" data-testid="digest-evals-pending">{data.evaluations_pending ?? 0}</div>
          <div className="text-xs text-[var(--ink-soft)] mt-1">evaluaciones pendientes de aprobar</div>
        </div>
        <div className="p-4 rounded-xl bg-[var(--cream)] border border-[var(--line)]">
          <div className="font-display text-4xl text-[var(--lala-blue)]" data-testid="digest-cr-pending">{data.pending_change_requests}</div>
          <div className="text-xs text-[var(--ink-soft)] mt-1">solicitudes de cambio pendientes</div>
        </div>
      </div>
      {data.level_changes.length > 0 && (
        <div className="mt-4" data-testid="digest-level-changes">
          <div className="text-xs uppercase tracking-wider text-[var(--ink-soft)] mb-2">Proveedores que cambiaron de nivel esta semana</div>
          <ul className="space-y-1">
            {data.level_changes.slice(0, 10).map((c, i) => (
              <li key={i} className="text-sm flex items-center gap-2 flex-wrap">
                <span className="font-semibold">{c.name}</span>
                <span className="text-xs text-[var(--ink-soft)]">({c.category})</span>
                <span className="text-xs">{lbl(c.from)} → <strong>{lbl(c.to)}</strong></span>
                <span className="text-[11px] text-[var(--ink-soft)]">{toBase10(c.avg_from)?.toFixed(1)} → {toBase10(c.avg_to)?.toFixed(1)} / 10</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
